// @flow

import React from 'react';

import ShowHelp from './HelpDropdown/ShowHelp';
import { HeaderContentMenu, LogInLink } from './styles';
import UserDropdown from './UserDropdown';

import type { Map } from 'immutable';
import type { Node } from 'react';

type LargeHeaderContentProps = {|
  children?: Node,
  onClickLogin: () => void,
  onClickLogout: () => void,
  userAvatarUrl?: string,
  userData: Map,
  userLoggedIn: boolean,
  username: ?string,
|};

const LargeHeaderContent = ({
  children,
  onClickLogin,
  onClickLogout,
  userAvatarUrl,
  userData,
  userLoggedIn,
  username,
}: LargeHeaderContentProps) => {
  return (
    <HeaderContentMenu aria-label="Site Navigation">
      {children}
      <ShowHelp userLoggedIn={userLoggedIn} />
      {userLoggedIn ? (
        <UserDropdown
          onClickLogout={onClickLogout}
          userData={userData}
          userAvatarUrl={userAvatarUrl}
          username={username}
        />
      ) : (
        <LogInLink
          className="log-in-link"
          href={userData.getIn(['_links', 'login', 'href'])}
          onClick={onClickLogin}
        >
          Log in
        </LogInLink>
      )}
    </HeaderContentMenu>
  );
};

export default LargeHeaderContent;
